import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";

import { DataTableViewOptions, simpleTextColumn } from "@/components/DataTable";
import { dateAndDurationColumn } from "@/components/DataTable/Columns/dateAndDurationColumn";

import { Columns } from "../-constants";
import { CertificationsTableRow } from "../-query/type";

import nameColumn from "./nameColumn";

export function useCertificationsColumns(): ColumnDef<CertificationsTableRow>[] {
  return useMemo(() => {
    const columns = [
      nameColumn(),
      simpleTextColumn(Columns.CERTIFICATION_NUMBER, {
        i18nKey: "educationsAndQualifications.certificationNumber",
        minWidth: "240px",
        sortable: true,
        enableHiding: true,
      }) as ColumnDef<CertificationsTableRow>,
      dateAndDurationColumn(Columns.LAST_RENEWAL_DATE, "date", {
        i18nKey: "educationsAndQualifications.lastRenewalDate",
        minWidth: "240px",
        sortable: true,
        enableHiding: true,
      }) as ColumnDef<CertificationsTableRow>,
      dateAndDurationColumn(Columns.VALID_TO, "date", {
        i18nKey: "educationsAndQualifications.validTo",
        minWidth: "240px",
        sortable: true,
        enableHiding: true,
      }) as ColumnDef<CertificationsTableRow>,
      dateAndDurationColumn(Columns.RENEWAL_DEADLINE, "date", {
        i18nKey: "educationsAndQualifications.renewalDeadline",
        minWidth: "240px",
        sortable: true,
        enableHiding: true,
      }) as ColumnDef<CertificationsTableRow>,
    ] satisfies ColumnDef<CertificationsTableRow>[];

    columns.push(ActionsColumn("actions"));

    return columns;
  }, []);
}

/** アクションを表示するカラム */
export function ActionsColumn(
  id = "actions",
): ColumnDef<CertificationsTableRow> {
  return {
    accessorKey: id,
    enableSorting: false,
    header: ({ table }) => (
      <div className="flex justify-end pr-2">
        <DataTableViewOptions table={table} />
      </div>
    ),
    cell: () => <></>,
  };
}
